import React from "react";
import { Container } from "reactstrap";
import { FaFacebookF, FaTwitter, FaSkype, FaGoogle } from "react-icons/fa";
import { ImInstagram } from "react-icons/im";
import { FiDribbble } from "react-icons/fi";
import Footer from "../../components/user/Footer";
import GetInTouch from "../../components/user/Contact";

function Contact() {
  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          Contact Us
        </p>
      </div>

      <div className="py-5">
        <Container>
          <div className="row">
            <div className="col-3 text-center">
              <p className="fw-bold pb-2 fs-5">Call Us</p>
              <p>0123 456 789</p>
            </div>

            <div className="col-3 text-center">
              <p className="fw-bold pb-2 fs-5">Address</p>
              <p>abcde@gmail.com</p>
            </div>

            <div className="col-3 text-center">
              <p className="fw-bold pb-2 fs-5">We're Open</p>
              <p>Mon - Fri : 8:00 - 17:00</p>
            </div>

            <div className="col-3 text-center">
              <p className="fw-bold pb-2 fs-5">Social Media</p>
              <div className="icon_social">
                <FaFacebookF className="me-2" />
                <FaTwitter className="me-2" />
                <FaGoogle className="me-2" />
                <ImInstagram className="me-2" />
                <FiDribbble className="me-2" />
                <FaSkype className="me-2" />
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="border_top">
        <GetInTouch />
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
